import { defineStore } from 'pinia';
import { ref } from '@vue/composition-api';
import { AnalyticsAppType, analyticsManager } from '@/utils/mixins/analytics';

export const useCompanyStore = defineStore('company', () => {
  const selectedCompany = ref<string>('0');
  const companies = ref<object>([]);

  function setSelectedCompany(id: string) {
    selectedCompany.value = id;
    analyticsManager.setDeviceId(AnalyticsAppType.WORKSPACE, id, false);
  }

  function setCompanies(_companies: object) {
    companies.value = _companies;
  }

  return {
    companies,
    setCompanies,
    selectedCompany,
    setSelectedCompany,
  };
}, {
  persist: true,
});
